// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {useContext, useEffect} from 'react';
import {Content_context} from './contexts.js';

export function use_footer_content(content){
    const {set_f_content} = useContext(Content_context);
    useEffect(()=>{
        set_f_content(content);
        return ()=>set_f_content(null);
    }, [content]);
}

export function use_header_content(content){
    const {set_h_content} = useContext(Content_context);
    useEffect(()=>{
        set_h_content(content);
        return ()=>set_h_content(null);
    }, [content]);
}
